import { SortingState, Updater } from "@tanstack/react-table";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type DataTableStore = {
  sortingByTable: Record<string, SortingState>;
  setSorting: (tableId: string, updater: Updater<SortingState>) => void;
  resetSorting: (tableId: string) => void;
};

export const useDataTableStore = create<DataTableStore>()(
  persist(
    (set) => ({
      sortingByTable: {},
      setSorting: (tableId, updater) =>
        set((state) => {
          const next =
            typeof updater === "function"
              ? updater(state.sortingByTable[tableId])
              : updater;

          return {
            sortingByTable: { ...state.sortingByTable, [tableId]: next },
          };
        }),
      resetSorting: (tableId) =>
        set((state) => {
          const { [tableId]: _removed, ...rest } = state.sortingByTable;
          return { sortingByTable: rest };
        }),
    }),
    {
      name: "data-table-sorting-store",
    },
  ),
);
